import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { MapTooltip } from "../../../widgets/map/mapAddons/mapTooltip";
import { getBasicObjectTypeLayer, getAllRoadObjectsLayer } from "../../../widgets/map/mapFeatures/layers";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { getObjectsOnMapPoint } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { DiagnosticsYearFilters } from "../../../widgets/diagnosticsYearFilters";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { showMapTooltip } from "../../../widgets/map/mapFeatures/mapFunctions/showMapTooltip/showMapTooltip";
import { useDispatch } from "react-redux";
import { setMapTooltipIsVisible } from "../../../stateManagement/reducers/MapTooltipSlice";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import TableUnderMap from "../../tables/tableUnderMap/TableUnderMap";
import { mapLayersDict } from "../mapLayersDict";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

export function MapRoadAccidentSegments() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapName = "RoadAccidentSegments"
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [isSmallWindow, setIsSmallWindow] = useState(false);
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const yearFilter = useAppSelector(state => state.roadAccidentSegments.roadAccidentSegmentsMapYearFilter)
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)
    const { wmsServer, wmsVersion, workspace } = getItemWebStorage('currentConfig')

    const roadsLayer = getAllRoadObjectsLayer()
    const [permanentLayers] = useState([roadsLayer])

    useEffect(() => {
        const { mapLayer, caption } = mapLayersDict[mapName] ?? {}
        caption && setMapTitle(`Карта «${caption}»`)
        if (!mapLayer) {
            navigate('/app/error')
        }
        let layerFilter = `Year in (${yearFilter})`
        const objectTypeLayer = getBasicObjectTypeLayer(mapLayer, wmsServer, wmsVersion, workspace, layerFilter)
        setAdditionalLayers([objectTypeLayer])
    }, [yearFilter]);

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 400);
    }, [sideBarState, navigate])

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        const hasSeenYearForMobile = getItemWebStorage('diagnosticsYearFilters')?.roadAccidentSegmentsMapSeen
        if (!hasSeenYearForMobile && contentHeaderWidth < 400) {
            navigate('/app/map/RoadAccidentSegments/filters')
        }
    }, [])

    function applyMapTooltip(map: any) {
        const pointerMoveFunc = (event: any) => showMapTooltip(event, mapName, additionalLayers[0], map)
        map?.on("pointermove", pointerMoveFunc)
        return {
            off: () => {
                map?.un("pointermove", pointerMoveFunc)
                dispatch(setMapTooltipIsVisible(false))
            }
        }
    }

    function applyMapObjectsFind(map: any) {
        const clickFunc = (event: any) => getObjectsOnMapPoint(event, mapName, additionalLayers[0])
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "mapTooltip",
            func: applyMapTooltip
        },
        {
            name: "objectsFindAlways",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={mapName} type="map" option="roadAccidentSegments" />
            {!isSmallWindow && <DiagnosticsYearFilters type="header" filterType="RoadAccidentSegmentsMap" />}
            <div className={`map-widget-with-toast${!isSmallWindow ? ' with-year-filter-row' : ''}`}>
                <MapTooltip type={mapName} />
                <MapWidget additionalLayers={additionalLayers} mapEventHandlers={mapEventHandlers} permanentLayers={permanentLayers} highlightObjectColor="red" />
                <MapOverlayWidget />
                {tableUnderMapIsShown && <TableUnderMap objectType="RoadAccidentSegments" canBeFiltered={false} filtersExpression={`Year eq ${yearFilter}`} />}
            </div>
        </>
    )
}
